import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import handleOpenWhatsApp from 'services/whatsappService';
import CheckList from '../../CherrySoftware/components/CheckList';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import { hubCta } from '../mediaLabHubContent';

const HubCta = () => {
  const theme = useTheme();

  return (
    <Box
      py={{ xs: 8, md: 10 }}
      px={{ xs: 2, md: 3 }}
      textAlign="center"
      sx={{
        borderRadius: { md: 4 },
        color: 'common.white',
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(135deg, ${theme.palette.primary.dark || theme.palette.primary.main} 0%, ${theme.palette.primary.main} 50%, ${alpha(theme.palette.secondary.main, 0.95)} 100%)`,
        boxShadow: `0 28px 70px ${alpha(theme.palette.primary.main, 0.28)}`,
      }}
    >
      <Box position="relative" zIndex={1}>
        <Box display="flex" justifyContent="center" mb={2}>
          <IconBadge icon="launch" size={56} variant="soft" rounded="18px" />
        </Box>
        <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 1.4, opacity: 0.9 }}>
          {hubCta.overline}
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontWeight: 800, lineHeight: 1.15, mt: 1, mb: 2, maxWidth: 720, mx: 'auto' }}
        >
          {hubCta.title}
        </Typography>
        <Typography
          variant="h6"
          sx={{ opacity: 0.92, lineHeight: 1.7, maxWidth: 640, mx: 'auto', mb: 3 }}
        >
          {hubCta.subtitle}
        </Typography>
        <Box maxWidth={420} mx="auto" textAlign="left" mb={3}>
          <CheckList items={hubCta.bullets} dense inverted />
        </Box>
        <Box
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          justifyContent="center"
          alignItems="center"
          style={{ gap: 12 }}
        >
          <Button
            variant="contained"
            size="large"
            startIcon={<WhatsAppIcon />}
            onClick={() => handleOpenWhatsApp()}
            sx={{
              bgcolor: 'common.white',
              color: theme.palette.primary.main,
              px: 4,
              py: 1.45,
              fontWeight: 800,
              borderRadius: 2,
              '&:hover': { bgcolor: alpha(theme.palette.common.white, 0.92) },
            }}
          >
            {hubCta.cta}
          </Button>
          <Button
            variant="outlined"
            size="large"
            href={hubCta.secondaryHref}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              borderColor: 'common.white',
              color: 'common.white',
              px: 3.5,
              py: 1.4,
              fontWeight: 700,
              borderRadius: 2,
              '&:hover': {
                borderColor: 'common.white',
                bgcolor: alpha(theme.palette.common.white, 0.1),
              },
            }}
          >
            {hubCta.secondaryCta}
          </Button>
        </Box>
        <Typography variant="subtitle2" sx={{ mt: 5, opacity: 0.8 }}>
          {hubCta.copyright}
        </Typography>
      </Box>
    </Box>
  );
};

export default HubCta;
